import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import RadioButton from 'LuxKit/Radio/RadioButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { capitalise } from 'lib/string/stringUtils'

const CardOption = styled.label<{ $selected: boolean }>`
  display: grid;
  grid-template-columns: auto auto 1fr;
  gap: ${rem(12)};
  align-items: center;
  min-height: ${rem(48)};
  padding: ${rem(12)};
  border: 1px solid ${props => props.$selected ? props.theme.palette.highlight.luxPlus.normalForeground : props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.L};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  cursor: pointer;
`

const CardLogo = styled.img`
  max-width: ${rem(24)};
  max-height: ${rem(16)};
`

const CardDetails = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
`

interface Props {
  cards: Array<App.StripePaymentCardV2>
  disabled: boolean
  selectedPaymentMethodId?: string
  onSelect: (paymentMethodId: string) => void
}

function LuxPlusInvalidCardModalCardPicker({ cards, disabled, selectedPaymentMethodId, onSelect }: Props) {
  const intl = useIntl()

  return <Group direction="vertical" gap={8}>
    <Heading variant="heading6">
      {intl.formatMessage({
        id: 'xzhNV2qxOzzvslFCfP5m',
        defaultMessage: 'Choose a saved card for your renewal',
        description: 'Heading above the saved cards the member can pick as their new LuxPlus+ renewal card in the invalid card modal',
      })}
    </Heading>
    {cards.map(card => <CardOption key={card.paymentMethodId} $selected={card.paymentMethodId === selectedPaymentMethodId}>
      <RadioButton
        checked={card.paymentMethodId === selectedPaymentMethodId}
        disabled={disabled}
        name="lux-plus-invalid-card-replacement"
        onChange={() => onSelect(card.paymentMethodId)}
        size="small"
      />
      {card.logo ? <CardLogo src={card.logo} alt="" /> : <span />}
      <CardDetails>
        <BodyText variant="medium" wrap="truncate">
          {intl.formatMessage({
            id: 'IGJps304HhhneW0kwTrn',
            defaultMessage: '{cardBrand} ending {last4}',
            description: 'Saved card option in the LuxPlus+ invalid card modal showing the card brand and last four digits',
          }, { cardBrand: capitalise(card.brand), last4: card.last4 })}
        </BodyText>
        <BodyText variant="small" colour="neutral-two">
          {intl.formatMessage({
            id: 'IDXeYxXLHu0SKBFYHHaO',
            defaultMessage: 'Exp. {cardExpiry}',
            description: 'Expiry date of a saved card option in the LuxPlus+ invalid card modal',
          }, { cardExpiry: card.expiry })}
        </BodyText>
      </CardDetails>
    </CardOption>)}
  </Group>
}

export default LuxPlusInvalidCardModalCardPicker
